import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the communicationDetailMobile state domain
 */

const selectCommunicationDetailMobileDomain = state =>
  state.communicationDetailMobile || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.ID,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.firstRender,
  );

const makeSelectItemDetail = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.itemDetail,
  );

const makeSelectUpdateLoading = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.updateLoading,
  );

/**
 * Default selector used by Communication
 */

const makeSelectCommunicationDetailMobile = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate,
  );

export default makeSelectCommunicationDetailMobile;
export {
  selectCommunicationDetailMobileDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemDetail,
  makeSelectUpdateLoading,
};
